import { useEffect, useState } from "react";
import { Search, Ban, RotateCcw } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { FullSpinner } from "@/components/States";
import { toast } from "sonner";

export default function AdminUsers() {
  const [data, setData] = useState(null);
  const [q, setQ] = useState("");
  const [page, setPage] = useState(1);

  const load = (pg = page, query = q) => api.get(`/admin/users?q=${encodeURIComponent(query)}&page=${pg}`).then(({ data }) => setData(data));
  useEffect(() => { load(1); /* eslint-disable-next-line */ }, []);

  const action = async (uid, act) => { try { await api.post(`/admin/users/${uid}/${act}`); toast.success("Done"); load(); } catch (e) { toast.error(apiError(e)); } };

  if (!data) return <FullSpinner label="Loading users…" />;
  return (
    <div className="space-y-5" data-testid="admin-users">
      <h1 className="font-serif text-3xl font-bold">User Management</h1>
      <div className="flex gap-2 max-w-md">
        <div className="flex-1 flex items-center gap-2 bg-[#2A0F14] border border-[#781826]/40 rounded-xl px-3">
          <Search className="w-4 h-4 text-[#C59B27]" />
          <input className="flex-1 bg-transparent py-2.5 text-sm outline-none text-[#FAF5F0]" placeholder="Search name, mobile, email, Profile ID" value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load(1)} data-testid="admin-user-search" />
        </div>
        <button onClick={() => load(1)} className="btn-gold px-4 rounded-xl">Search</button>
      </div>
      <div className="bg-[#2A0F14] border border-[#781826]/40 rounded-2xl overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-xs text-[#C59B27] uppercase border-b border-[#781826]/40"><th className="p-3">Name</th><th>Profile ID</th><th>Mobile</th><th>Plan</th><th>Status</th><th>Actions</th></tr></thead>
          <tbody>
            {data.users.map((u) => (
              <tr key={u.id} className="border-b border-[#781826]/20" data-testid={`admin-user-${u.id}`}>
                <td className="p-3">{u.profile?.full_name || "—"}<div className="text-xs text-[#8A6D71]">{u.profile?.city} · {u.profile?.age}</div></td>
                <td className="font-mono text-xs">{u.profile?.profile_code}</td>
                <td>{u.mobile}</td>
                <td className="capitalize">{u.subscription?.lifetime ? "lifetime" : u.subscription?.plan}</td>
                <td><span className={`text-xs px-2 py-0.5 rounded-full ${u.status === "active" ? "bg-emerald-900/40 text-emerald-300" : "bg-rose-900/40 text-rose-300"}`}>{u.status}</span></td>
                <td>
                  <div className="flex items-center gap-3">
                    <a href={`/admin/user/${u.id}`} className="text-xs text-[#C59B27]" data-testid={`admin-user-360-${u.id}`}>360°</a>
                    {u.status === "active" ? (
                      <button onClick={() => action(u.id, "suspend")} className="text-xs text-rose-300 flex items-center gap-1"><Ban className="w-3.5 h-3.5" /> Suspend</button>
                    ) : (
                      <button onClick={() => action(u.id, "reactivate")} className="text-xs text-emerald-300 flex items-center gap-1"><RotateCcw className="w-3.5 h-3.5" /> Reactivate</button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {data.pages > 1 && (
        <div className="flex gap-2">{[...Array(data.pages)].slice(0, 10).map((_, i) => <button key={i} onClick={() => { setPage(i + 1); load(i + 1); }} className={`w-8 h-8 rounded-lg text-sm ${data.page === i + 1 ? "bg-[#C59B27] text-[#3B0A12]" : "bg-[#2A0F14] text-[#D8B4B9]"}`}>{i + 1}</button>)}</div>
      )}
    </div>
  );
}
